import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { setConfig } from "@shared/services/api/config";
import { initFirebase } from "@shared/services/api/firebase";
import { DialogProvider } from "@shared/features/dialog/DialogContext";
import { MobileMenuProvider } from "@shared/features/mobileMenu/MobileMenuContext";
import { TrackingProvider } from "@shared/features/tracking/TrackingContext";
import { OnboardingProvider } from "./features/onboarding/OnboardingContext";
import { DashboardProvider } from "./features/dashboard/DashboardContext";
import { SupportProvider } from "./features/support/SupportContext";
import { NotificationsProvider } from "./features/notifications/NotificationsContext";
import { PlatformProvider } from "./PlatformContext";
import { PlatformApp } from "./PlatformApp";
import "@shared/styles/index.css";

// Setup API config with env variables (env variables are not read in @shared)
setConfig({
  appName: "platform",
  apiUrl: import.meta.env.VITE_API_URL,
  firebaseEnv: import.meta.env.VITE_FIREBASE_ENV,
  chimeApiUrl: import.meta.env.VITE_CHIME_API_URL,
  env: import.meta.env.MODE,
});

// Initialize Firebase
initFirebase();

// Create a query client
const queryClient = new QueryClient();

// Create root element and render the app
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TrackingProvider
          debug={{ enabled: false }}
          services={{ posthog: true, google_analytics: true }}
        >
          <NotificationsProvider>
            <DialogProvider>
              <PlatformProvider>
                <MobileMenuProvider>
                  <OnboardingProvider>
                    <DashboardProvider>
                      <SupportProvider>
                        <PlatformApp />
                      </SupportProvider>
                    </DashboardProvider>
                  </OnboardingProvider>
                </MobileMenuProvider>
              </PlatformProvider>
            </DialogProvider>
          </NotificationsProvider>
        </TrackingProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
